/* eslint-disable no-case-declarations */
import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { map, exhaustMap, catchError, withLatestFrom, switchMap } from 'rxjs/operators';
import { CustomService } from '../../services/custom/custom.service';
import * as sharedAction from '../shared/shared.actions';
import * as CustomActions from './custom.actions';
import {
  CustomConversionDataGridService,
  CustomFillingsDataGridService,
  CustomMaterialsDataGridService,
  CustomReuseDataGridService,
  CustomStorageDataGridService,
  CustomTrucksDataGridService,
  WasteDataGridService,
  CustomTransportDataGridService,
} from '@piqet-angular/features';
import { select, Store } from '@ngrx/store';
import * as customSelector from './custom.selectors';
import { CustomModalService, DELETE_RECORD_LABEL } from '@piqet-angular/shared';
import { CustomFacade } from './custom.facade';
import { cloneDeep } from 'lodash';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';

@Injectable()
export class CustomEffects {
  deleteCustomData: any;
  editTimeData: any;

  private actions$ = inject(Actions);
  isAdmin: any;

  //Effects for getCustomTruckList.
  getCustomTruckList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.getCustomTruckList),
      exhaustMap(action => {
        if (action.pathName == 'customTrucks' || action.payload.pathName == 'customTrucks') {
          return this.CustomService.GetCustomTruckList(
            action.payload.customTruckPayload || action.payload
          ).pipe(
            map((data: any) => {
              return CustomActions.getCustomTruckListSuccess({
                customTruckList: data.data,
              });
            }),
            catchError((error: any) => of(CustomActions.getCustomTruckListFailure(error)))
          );
        } else {
          return this.CustomService.GetCustomTruckListForAdmin(
            action.payload.customTruckPayload || action.payload
          ).pipe(
            map((data: any) => {
              return CustomActions.getCustomTruckListSuccess({
                customTruckList: data.data,
              });
            }),
            catchError((error: any) => of(CustomActions.getCustomTruckListFailure(error)))
          );
        }
      })
    )
  );

  //Effects for getCustomStorageList.
  getCustomStorageList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.getCustomStorageList),
      exhaustMap(action => {
        if (action.pathName == 'customStorage' || action.payload.pathName == 'customStorage') {
          return this.CustomService.getCustomStorageList(
            action.payload.customStoragePayload || action.payload
          ).pipe(
            map((data: any) => {
              return CustomActions.getCustomStorageListSuccess({
                customStorageList: data.data,
              });
            }),
            catchError((error: any) => of(CustomActions.getCustomStorageListFailure(error)))
          );
        } else {
          return this.CustomService.getCustomStorageListForAdmin(
            action.payload.customStoragePayload || action.payload
          ).pipe(
            map((data: any) => {
              return CustomActions.getCustomStorageListSuccess({
                customStorageList: data.data,
              });
            }),
            catchError((error: any) => of(CustomActions.getCustomStorageListFailure(error)))
          );
        }
      })
    )
  );

  getCustomStorageListSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.getCustomStorageListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );

  //Effects for getCustomtransportList.
  getCustomtransportList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.getCustomTransportList),
      exhaustMap(action => {
        return this.CustomService.getCustomTransportListForAdmin(
          action.payload.customTransportScenarioPayload || action.payload
        ).pipe(
          map((data: any) => {
            return CustomActions.getCustomTransportListSuccess({
              customTransportList: data.data,
            });
          }),
          catchError((error: any) => of(CustomActions.getCustomTransportListFailure(error)))
        );
        // }
      })
    )
  );

  getCustomTransportListSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.getCustomTransportListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );

  //Effects for deleteCustomData.
  deleteCustomData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.deleteCustomData),
      exhaustMap(action => {
        return this.CustomService.deleteCustomData(action.payload, action.customType).pipe(
          map((data: any) => {
            data['pathName'] = action.pathName;
            data.messageType
              ? this.toaster.error(data.message)
              : this.toaster.success(data.message);
            return CustomActions.deleteCustomDataSuccess({
              deleteCustomDataMessage: data,
              id: action.payload,
            });
          }),
          catchError((error: any) => of(CustomActions.deleteCustomDataFailure(error)))
        );
      })
    )
  );

  deleteCustomDataSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.deleteCustomDataSuccess),
      exhaustMap(action => {
        switch (action.deleteCustomDataMessage.pathName) {
          case 'customConversion':
          case 'adminCustomConversion':
            const conversion = {
              // customConversionPayload: this.customConversionDataService.getPayload(''),
              pathName: action.deleteCustomDataMessage.pathName,
            };
            return of(
              CustomActions.getCustomConversionList({ payload: conversion }),
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'customReuse':
          case 'adminCustomReuse':
            const reuse = {
              customReusePayload: this.customReuseDataService.getPayload(''),
              pathName: action.deleteCustomDataMessage.pathName,
            };
            return of(
              CustomActions.getCustomReuseList({ payload: reuse }),
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'customStorage':
          case 'adminCustomStorage':
            const storage = {
              customStoragePayload: this.customStorageDataGridService.getPayload(''),
              pathName: action.deleteCustomDataMessage.pathName,
            };
            return of(
              CustomActions.getCustomStorageList({ payload: storage }),
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'customTrucks':
          case 'adminCustomTrucks':
            const truck = {
              customTruckPayload: this.customTruckDataService.getPayload(''),
              pathName: action.deleteCustomDataMessage.pathName,
            };
            return of(
              CustomActions.getCustomTruckList({ payload: truck }),
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'customFilling':
          case 'adminCustomFilling':
            const filling = {
              customFillingPayload: this.CustomFillingsDataGridService.getPayload(''),
              pathName: action.deleteCustomDataMessage.pathName,
            };
            return of(
              CustomActions.getCustomFillingList({ payload: filling }),
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'customWaste':
          case 'adminWasteScenarios':
            const waste = {
              customWastePayload: this.wasteDataGridService.getPayload(''),
              pathName: action.deleteCustomDataMessage.pathName,
            };
            return of(
              CustomActions.getCustomWasteList({ payload: waste }),
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'customTransport':
          case 'adminCustomTransport':
            return of();
            break;
          default:
            return of(
              sharedAction.ToasterSuccess({ description: 'data deleted successfully.' }),
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
        }
      })
    )
  );

  addEditCustomMaterial$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.addEditCustomMaterial),
      exhaustMap(action => {
        if (action.customMaterialData.pathName == 'customMaterials') {
          return this.CustomService.addCustomMaterial(action.customMaterialData.payload).pipe(
            map((data: any) => {
              data['pathName'] = action.customMaterialData.pathName;

              data.messageType
                ? this.toaster.error(data.message)
                : this.toaster.success(data.message);
              // const deepCopy = JSON.parse(JSON.stringify(action.customMaterialData.payload));
              // deepCopy.customMaterialId = data.data.customMaterialId;
              return CustomActions.addEditCustomMaterialSuccess({
                customMaterialData: action.customMaterialData.payload,
              });
            }),
            catchError((error: any) => of(CustomActions.addEditCustomMaterialFailure(error)))
          );
        } else {
          return this.CustomService.addCustomMaterialForAdmin(
            action.customMaterialData.payload
          ).pipe(
            map((data: any) => {
              return CustomActions.addEditCustomMaterialSuccess({
                customMaterialData: data,
              });
            }),
            catchError((error: any) => of(CustomActions.addEditCustomMaterialFailure(error)))
          );
        }
      })
    )
  );

  addEditCustomConversion$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.addEditCustomConversion),
      exhaustMap(action => {
        if (action.customConversionData.pathName == 'customConversion') {
          return this.CustomService.addCustomConversion(action.customConversionData.payload).pipe(
            map((data: any) => {
              data['pathName'] = action.customConversionData.pathName;
              return CustomActions.addEditCustomConversionSuccess({
                customConversionData: data,
              });
            }),
            catchError((error: any) => of(CustomActions.addEditCustomConversionFailure(error)))
          );
        } else {
          return this.CustomService.addCustomConversionForAdmin(
            action.customConversionData.payload
          ).pipe(
            map((data: any) => {
              return CustomActions.addEditCustomConversionSuccess({
                customConversionData: data,
              });
            }),
            catchError((error: any) => of(CustomActions.addEditCustomConversionFailure(error)))
          );
        }
      })
    )
  );

  addEditCustomConversionSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.addEditCustomConversionSuccess),
      exhaustMap(action => {
        if (action.customConversionData.messageType != 0) {
          return of(
            CustomActions.addEditCustomConversionFailure({
              error: action.customConversionData.message,
            }),
            sharedAction.ToasterError({ description: action.customConversionData.message })
          );
        } else {
          this.modal.close();
          //this.customFacade.clearConversionProcess();
          const data = {
            pathName: action.customConversionData.pathName,
          };
          return of(
            CustomActions.getCustomConversionList({ payload: data }),
            sharedAction.ToasterSuccess({ description: action.customConversionData.message }),
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );

  deleteCustomDataEffect$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(CustomActions.deleteCustom),
        withLatestFrom(this.store.pipe(select(customSelector.GetDeleteCustomData))),
        exhaustMap((action: any) => {
          return this.alertConfirmation(action);
        })
      ),
    { dispatch: false }
  );

  //Effects for copyCustomData.
  copyCustomData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.copyCustomData),
      exhaustMap(action => {
        return this.CustomService.copyCustomData(action.payload, action.customType).pipe(
          map((data: any) => {
            data['pathName'] = action.pathName;
            return CustomActions.copyCustomDataSuccess({
              copyCustomDataMessage: data,
            });
          }),
          catchError((error: any) => of(CustomActions.copyCustomDataFailure(error)))
        );
      })
    )
  );

  copyCustomDataSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.copyCustomDataSuccess),
      exhaustMap(action => {
        const toaster = action.copyCustomDataMessage.messageType
          ? sharedAction.ToasterError({ description: action.copyCustomDataMessage.message })
          : sharedAction.ToasterSuccess({ description: action.copyCustomDataMessage.message });
        switch (action.copyCustomDataMessage.pathName) {
          case 'customConversion':
          case 'adminCustomConversion':
            const conversion = {
              // customConversionPayload: this.customConversionDataService.getPayload(''),
              pathName: action.copyCustomDataMessage.pathName,
            };
            return of(
              CustomActions.getCustomConversionList({ payload: conversion }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'customReuse':
          case 'adminCustomReuse':
            const reuse = {
              customReusePayload: this.customReuseDataService.getPayload(''),
              pathName: action.copyCustomDataMessage.pathName,
            };
            return of(
              CustomActions.getCustomReuseList({ payload: reuse }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'customStorage':
          case 'adminCustomStorage':
            const storage = {
              customStoragePayload: this.customStorageDataGridService.getPayload(''),
              pathName: action.copyCustomDataMessage.pathName,
            };
            return of(
              CustomActions.getCustomStorageList({ payload: storage }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'customTrucks':
          case 'adminCustomTrucks':
            const truck = {
              customTruckPayload: this.customTruckDataService.getPayload(''),
              pathName: action.copyCustomDataMessage.pathName,
            };
            return of(
              CustomActions.getCustomTruckList({ payload: truck }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'customFilling':
          case 'adminCustomFilling':
            const filling = {
              customFillingPayload: this.CustomFillingsDataGridService.getPayload(''),
              pathName: action.copyCustomDataMessage.pathName,
            };
            return of(
              CustomActions.getCustomFillingList({ payload: filling }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'wasteScenarios':
          case 'adminWasteScenarios':
            const waste = {
              customWastePayload: this.wasteDataGridService.getPayload(''),
              pathName: action.copyCustomDataMessage.pathName,
            };
            return of(
              CustomActions.getCustomWasteList({ payload: waste }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
          case 'customTransport':
          case 'adminCustomTransport':
            return of();
            break;
          default:
            return of(
              sharedAction.ToasterSuccess({ description: 'data deleted successfully.' }),
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
            break;
        }
      })
    )
  );

  customMaterialCopy$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.customMaterialCopy),
      withLatestFrom(this.store.pipe(select(customSelector.GetCopiedCustomMaterial))),
      exhaustMap((action: any) => {
        this.modal.invoke('copyCustom', {
          initialState: {
            paramData: action[0].action.name || action[0].action.processName,
            copyHeaderName: action[0].pathName,
            organizationName: action[0].action?.organizationName,
          },
          class: 'modal-xl',
        });
        return of(
          this.modal.ref?.content.copyCustom.subscribe((data: any) => {
            const payload = {
              Id:
                action[0].action.id ||
                action[0].action.customMaterialId ||
                action[0].action.wasteScenarioId ||
                action[0].action.truckId,
              Name: data.name,
            };
            this.customFacade.copyCustomData(payload, action[0].customType, action[0].pathName);
          })
        );
      })
    )
  );

  addEditCustomFilling$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.addEditCustomFilling),
      exhaustMap(action => {
        if (action.customFillingData.pathName == 'customFilling') {
          return this.CustomService.addCustomFilling(action.customFillingData.payload).pipe(
            map((data: any) => {
              data['pathName'] = action.customFillingData.pathName;
              return CustomActions.addEditCustomFillingSuccess({
                customFillingData: data,
              });
            }),
            catchError((error: any) => of(CustomActions.addEditCustomFillingFailure(error)))
          );
        } else {
          return this.CustomService.addCustomFillingForAdmin(action.customFillingData.payload).pipe(
            map((data: any) => {
              return CustomActions.addEditCustomFillingSuccess({
                customFillingData: data,
              });
            }),
            catchError((error: any) => of(CustomActions.addEditCustomFillingFailure(error)))
          );
        }
      })
    )
  );

  addEditCustomFillingSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.addEditCustomFillingSuccess),
      exhaustMap(action => {
        if (action.customFillingData.messageType != 0) {
          return of(
            CustomActions.addEditCustomFillingFailure({ error: action.customFillingData.message })
          );
        } else {
          this.modal.close();
          this.customFacade.clearFillingIngredient();
          const data = {
            customFillingPayload: this.CustomFillingsDataGridService.getPayload(''),
            pathName: action.customFillingData.pathName,
          };
          return of(
            CustomActions.getCustomFillingList({ payload: data }),
            sharedAction.ToasterSuccess({ description: action.customFillingData.message }),
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );

  addEditCustomTruck$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.addEditCustomTruck),
      exhaustMap(action => {
        if (action.customTruckData.pathName == 'customTrucks') {
          return this.CustomService.addEditCustomTruck(action.customTruckData.payload).pipe(
            map((data: any) => {
              data['pathName'] = action.customTruckData.pathName;
              return CustomActions.addEditCustomTruckSuccess({
                customTruckData: data,
              });
            }),
            catchError((error: any) => of(CustomActions.addEditCustomTruckFailure(error)))
          );
        } else {
          return this.CustomService.addEditCustomTruckForAdmin(action.customTruckData.payload).pipe(
            map((data: any) => {
              return CustomActions.addEditCustomTruckSuccess({
                customTruckData: data,
              });
            }),
            catchError((error: any) => of(CustomActions.addEditCustomTruckFailure(error)))
          );
        }
      })
    )
  );

  addEditCustomTruckSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.addEditCustomTruckSuccess),
      exhaustMap(action => {
        if (action.customTruckData.messageType != 0) {
          return of(
            CustomActions.addEditCustomTruckFailure({ error: action.customTruckData.message })
          );
        } else {
          this.modal.close();
          const data = {
            customTruckPayload: this.customTruckDataService.getPayload(''),
            pathName: action.customTruckData.pathName,
          };
          return of(
            CustomActions.getCustomTruckList({ payload: data }),
            sharedAction.ToasterSuccess({ description: action.customTruckData.message }),
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );

  openAddEditCustomStorageModal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.openAddEditCustomStorageModal),
      exhaustMap(action => {
        if (action.pathName == 'customStorage') {
          return this.CustomService.getStorage(action.customStorageId).pipe(
            map((data: any) => {
              if (action.actionLabel == 'Review custom storage') {
                data.data.customStorageProcesses = data.data.customStorageProcesses.map(
                  (item: any) => {
                    return {
                      ...item,
                      index: item.id,
                    };
                  }
                );
              }
              return CustomActions.openAddEditCustomStorageModalSuccess({
                customStoragedata: data,
              });
            })
          );
        } else {
          return this.CustomService.getStorageForAdmin(action.customStorageId).pipe(
            map((data: any) => {
              if (action.actionLabel == 'Review custom storage') {
                data.data.customStorageProcesses = data.data.customStorageProcesses.map(
                  (item: any) => {
                    return {
                      ...item,
                      index: item.id,
                    };
                  }
                );
              }

              return CustomActions.openAddEditCustomStorageModalSuccess({
                customStoragedata: data,
              });
            })
          );
        }
      })
    )
  );

  openAddEditCustomMaterialModal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.openAddEditCustomMaterialModal),
      exhaustMap(action => {
        if (action.pathName == 'customMaterials') {
          return this.CustomService.getMateriallist(action.customMaterialId).pipe(
            map((data: any) => {
              if (action.actionLabel == 'Review custom material') {
                data.data.materialIngrediantsItems = data.data.materialIngrediantsItems.map(
                  (item: any) => {
                    return {
                      ...item,
                      index: item.id,
                    };
                  }
                );
                data.data.materialProcessItems = data.data.materialProcessItems.map((item: any) => {
                  return {
                    ...item,
                    index: item.id,
                    isEdit: true,
                  };
                });
                data.data.endofLifeIdentifierItems = data.data.endofLifeIdentifierItems.map(
                  (item: any) => {
                    return {
                      ...item,
                      index: item.id,
                      isEdit: true,
                    };
                  }
                );
              }
              return CustomActions.openAddEditCustomMaterialModalSuccess({
                customMaterialdata: data,
              });
            })
          );
        } else {
          return this.CustomService.getMateriallistForAdmin(action.customMaterialId).pipe(
            map((data: any) => {
              if (action.actionLabel == 'Review custom material') {
                data.data.materialIngrediantsItems = data.data.materialIngrediantsItems.map(
                  (item: any) => {
                    return {
                      ...item,
                      index: item.id,
                    };
                  }
                );
                data.data.materialProcessItems = data.data.materialProcessItems.map((item: any) => {
                  return {
                    ...item,
                    index: item.id,
                  };
                });
              }

              return CustomActions.openAddEditCustomMaterialModalSuccess({
                customMaterialdata: data,
              });
            })
          );
        }
      })
    )
  );

  openAddEditCustomConversionModal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.openAddEditCustomConversionModal),
      exhaustMap(action => {
        if (action.pathName == 'customConversion') {
          return this.CustomService.getConversionlist(action.customConversionId).pipe(
            map((data: any) => {
              if (action.actionLabel == 'Review custom conversion') {
                data.data.conversionProcessDetail = data.data.conversionProcessDetail.map(
                  (item: any) => {
                    return {
                      ...item,
                      index: item.id,
                    };
                  }
                );
              }
              return CustomActions.openAddEditCustomConversionModalSuccess({
                customConversiondata: data,
              });
            })
          );
        } else {
          return this.CustomService.getConversionlistForAdmin(action.customConversionId).pipe(
            map((data: any) => {
              if (action.actionLabel == 'Review custom conversion') {
                data.data.conversionProcessDetail = data.data.conversionProcessDetail.map(
                  (item: any) => {
                    return {
                      ...item,
                      index: item.id,
                    };
                  }
                );
              }
              return CustomActions.openAddEditCustomConversionModalSuccess({
                customConversiondata: data,
              });
            })
          );
        }
      })
    )
  );

  openAddEditCustomFiliingModal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.openAddEditCustomFiliingModal),
      exhaustMap(action => {
        if (action.pathName == 'customFilling') {
          return this.CustomService.getFillinglist(action.customFillingId).pipe(
            map((data: any) => {
              if (action.actionLabel == 'Review custom filling') {
                data.data.fillingProcessItems = data.data.fillingProcessItems.map((item: any) => {
                  return {
                    ...item,
                    index: item.id,
                  };
                });
              }
              return CustomActions.openAddEditCustomFiliingModalSuccess({
                customFillingdata: data,
              });
            })
          );
        } else {
          return this.CustomService.getFillinglistForAdmin(action.customFillingId).pipe(
            map((data: any) => {
              if (action.actionLabel == 'Review custom filling') {
                data.data.fillingProcessItems = data.data.fillingProcessItems.map((item: any) => {
                  return {
                    ...item,
                    index: item.id,
                  };
                });
              }
              return CustomActions.openAddEditCustomFiliingModalSuccess({
                customFillingdata: data,
              });
            })
          );
        }
      })
    )
  );

  addEditCustomWasteScenario$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.addEditCustomWasteScenario),
      exhaustMap(action => {
        if (action.customWasteScenarioData.pathName == 'wasteScenarios') {
          return this.CustomService.addCustomWasteScenario(
            action.customWasteScenarioData.payload
          ).pipe(
            map((data: any) => {
              data['pathName'] = action.customWasteScenarioData.pathName;
              return CustomActions.addEditCustomWasteScenarioSuccess({
                customWasteScenarioData: data,
              });
            }),
            catchError((error: any) => of(CustomActions.addEditCustomWasteScenarioFailure(error)))
          );
        } else {
          return this.CustomService.addCustomWasteScenarioForAdmin(
            action.customWasteScenarioData.payload
          ).pipe(
            map((data: any) => {
              return CustomActions.addEditCustomWasteScenarioSuccess({
                customWasteScenarioData: data,
              });
            }),
            catchError((error: any) => of(CustomActions.addEditCustomWasteScenarioFailure(error)))
          );
        }
      })
    )
  );

  addEditCustomWasteScenarioSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.addEditCustomWasteScenarioSuccess),
      exhaustMap(action => {
        if (action.customWasteScenarioData.messageType != 0) {
          return of(
            CustomActions.addEditCustomWasteScenarioFailure({
              error: action.customWasteScenarioData.message,
            })
          );
        } else {
          this.modal.close();
          // this.customFacade.clearWasteScenarioProcess();
          const data = {
            customWastePayload: this.wasteDataGridService.getPayload(''),
            pathName: action.customWasteScenarioData.pathName,
          };
          return of(
            CustomActions.getCustomWasteList({ payload: data }),
            sharedAction.ToasterSuccess({ description: action.customWasteScenarioData.message }),
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );

  openAddEditCustomReuseModal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.openAddEditCustomReuseModal),
      exhaustMap(action => {
        if (action.pathName == 'customReuse') {
          return this.CustomService.getReuseList(action.customReuseId).pipe(
            map((data: any) => {
              if (action.actionLabel == 'Review custom reuse') {
                data.data.customReuseProcesses = data.data.customReuseProcesses.map((item: any) => {
                  return {
                    ...item,
                    index: item.id,
                  };
                });
              }
              return CustomActions.openAddEditCustomReuseModalSuccess({
                customReuseData: data,
              });
            })
          );
        } else {
          return this.CustomService.getReuseListForAdmin(action.customReuseId).pipe(
            map((data: any) => {
              if (action.actionLabel == 'Review custom reuse') {
                data.data.customReuseProcesses = data.data.customReuseProcesses.map((item: any) => {
                  return {
                    ...item,
                    index: item.id,
                  };
                });
              }
              return CustomActions.openAddEditCustomReuseModalSuccess({
                customReuseData: data,
              });
            })
          );
        }
      })
    )
  );

  addEditCustomReuse$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.addEditCustomReuse),
      exhaustMap(action => {
        if (action.customReuseData.pathName == 'customReuse') {
          return this.CustomService.addCustomReuse(action.customReuseData.payload).pipe(
            map((data: any) => {
              data['pathName'] = action.customReuseData.pathName;
              return CustomActions.addEditCustomReuseSuccess({
                customReuseData: data,
              });
            }),
            catchError((error: any) => of(CustomActions.addEditCustomReuseFailure(error)))
          );
        } else {
          return this.CustomService.addCustomReuseForAdmin(action.customReuseData.payload).pipe(
            map((data: any) => {
              return CustomActions.addEditCustomReuseSuccess({
                customReuseData: data,
              });
            }),
            catchError((error: any) => of(CustomActions.addEditCustomReuseFailure(error)))
          );
        }
      })
    )
  );

  addEditCustomReuseSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.addEditCustomReuseSuccess),
      exhaustMap(action => {
        if (action.customReuseData.messageType != 0) {
          return of(
            CustomActions.addEditCustomReuseFailure({ error: action.customReuseData.message })
          );
        } else {
          this.modal.close();
          const data = {
            customReusePayload: this.customReuseDataService.getPayload(''),
            pathName: action.customReuseData.pathName,
          };
          return of(
            CustomActions.getCustomReuseList({ payload: data }),
            sharedAction.ToasterSuccess({ description: action.customReuseData.message }),
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );

  openAddEditCustomTransportScenarioModal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.openAddEditCustomTransportScenarioModal),
      exhaustMap(action => {
        if (action.pathName == 'customTransport') {
          return this.CustomService.getAddEditTransportScenarioList(
            action.customTransportScenarioId
          ).pipe(
            map((data: any) => {
              this.spinnerService.hide();

              if (action.actionLabel == 'Review custom transport chain') {
                data.data.customTransportScenarioDetails =
                  data.data?.customTransportScenarioDetails.map((el: any) => {
                    return {
                      ...el,
                      distance: el.isOrigin ? '' : el.distance,
                    };
                  });
                if (data.data.customSiteTransports.length) {
                  if (data.data?.customTransportScenarioDetails.length) {
                    data.data.customSiteTransports.forEach((el: any) => {
                      el['cityName'] =
                        data.data?.customTransportScenarioDetails.findIndex((x: any) =>
                          x.hasOwnProperty('cityName')
                        ) >= 0
                          ? data.data?.customTransportScenarioDetails
                              .map((element: any, index: any, array: any) => {
                                return array[index].cityName;
                              })
                              .join(', ')
                          : '';

                      el['transportIcons'] = data.data?.customTransportScenarioDetails.map(
                        (ele: any, index: any, arr: any) => {
                          return arr[index]?.imageName;
                        }
                      );
                    });
                  } else {
                    data.data.customSiteTransports.forEach((el: any) => {
                      const dataParam = el?.locationTransportationItems.length
                        ? el?.locationTransportationItems
                        : el?.distanceTransportationItems.length
                        ? el?.distanceTransportationItems
                        : [];
                      el['cityName'] =
                        dataParam.findIndex((x: any) => x.hasOwnProperty('cityName')) >= 0
                          ? dataParam
                              .map((element: any, index: any, array: any) => {
                                return array[index].cityName;
                              })
                              .join(', ')
                          : '';

                      el['transportIcons'] = dataParam.map((ele: any, index: any, arr: any) => {
                        return arr[index]?.imageName;
                      });
                    });
                  }
                }

                this.editTimeData = data.data.customSiteTransports;
              } else {
                this.editTimeData = [];
              }
              return CustomActions.openAddEditCustomTransportScenarioModalSuccess({
                customTransportScenarioData: data,
                transportFinalGrid: this.editTimeData,
              });
            })
          );
        } else {
          return this.CustomService.getAddEditTransportScenarioListForAdmin(
            action.customTransportScenarioId
          ).pipe(
            map((data: any) => {
              if (action.actionLabel == 'Review custom transport chain') {
                const multipleCityName =
                  data.data?.customSiteTransports[0]?.locationTransportationItems
                    .map((element: any, index: any, array: any) => {
                      const concatedOriginNames = array[index].cityName;
                      return concatedOriginNames;
                    })
                    .join(', ');
                this.editTimeData = [
                  {
                    siteName: data.data?.customSiteTransports[0]?.siteName,
                    siteId: data.data?.customSiteTransports[0]?.siteId,
                    productPercentage: data.data?.productPercentageSum,
                    cityName: multipleCityName || '',
                  },
                ];
              }
              return CustomActions.openAddEditCustomTransportScenarioModalSuccess({
                customTransportScenarioData: data,
                transportFinalGrid: this.editTimeData,
              });
            })
          );
        }
      })
    )
  );

  addEditCustomTransportScenario$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.addEditCustomTransportScenario),
      exhaustMap(action => {
        return this.CustomService.addEditTransportScenarioForAdmin(
          action.customTransportScenarioData.payload
        ).pipe(
          map((data: any) => {
            return CustomActions.addEditCustomTransportScenarioSuccess({
              customTransportScenarioData: data,
            });
          }),
          catchError((error: any) => of(CustomActions.addEditCustomTransportScenarioFailure(error)))
        );
      })
    )
  );

  addEditCustomTransportScenarioSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CustomActions.addEditCustomTransportScenarioSuccess),
      exhaustMap(action => {
        if (action.customTransportScenarioData.messageType != 0) {
          return of(
            CustomActions.addEditCustomTransportScenarioFailure({
              error: action.customTransportScenarioData.message,
            })
          );
        } else {
          this.modal.close();
          this.customFacade.clearTransportScenario();
          return of(
            sharedAction.ToasterSuccess({
              description: action.customTransportScenarioData.message,
            }),
            sharedAction.clearSearchFilter({ isClearSearch: true })
          );
        }
      })
    )
  );

  deleteCustomProcess(type: any) {
    return type.map((item: any, i: any) => {
      return {
        ...item,
        index: i + 1,
      };
    });
  }

  async alertConfirmation(action: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.customFacade.deleteCustomData(
          action[0].action.id ||
            action[0].action.customMaterialId ||
            action[0].action.wasteScenarioId ||
            action[0].action.truckId ||
            action[0].action.convertionProcessId,
          action[0].customType,
          action[0].pathName,
          action[0].action.regionId
        );
      }
    });
  }

  constructor(
    private CustomService: CustomService,
    public customMaterialDataService: CustomMaterialsDataGridService,
    public customConversionDataService: CustomConversionDataGridService,
    private customReuseDataService: CustomReuseDataGridService,
    private customTruckDataService: CustomTrucksDataGridService,
    private customStorageDataGridService: CustomStorageDataGridService,
    private CustomFillingsDataGridService: CustomFillingsDataGridService,
    private CustomTransportDataGridService: CustomTransportDataGridService,
    private wasteDataGridService: WasteDataGridService,
    private store: Store,
    private modal: CustomModalService,
    public spinnerService: NgxSpinnerService,
    private customFacade: CustomFacade,
    private toaster: ToastrService,
    private swalService: SwalService
  ) {}
}
